import { render, staticRenderFns } from "./JobJd.vue?vue&type=template&id=1ba0c251&scoped=true"
import script from "./JobJd.vue?vue&type=script&lang=js"
export * from "./JobJd.vue?vue&type=script&lang=js"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=1ba0c251&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba0c251",
  null
  
)

export default component.exports